import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FaPaperclip as ClipIcon } from 'react-icons/fa';
import {
  showModalForAttachments,
} from './store/actions';

class AttachmentsCellRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.string,
    data: PropTypes.shape({
      adjustmentId: PropTypes.string.isRequired,
      autoAdjustmentId: PropTypes.number,
    }).isRequired,

    showModalForAttachments: PropTypes.func.isRequired,
  };

  showModalForAttachments = () => {
    this.props.showModalForAttachments(this.props.data);
  };

  render() {
    const { value } = this.props;

    return (
      <span>
        {value && (
          <button
            className="cell-icon-button"
            title="View Attachments"
            onClick={this.showModalForAttachments}
          >
            <ClipIcon size={16} className="cell-icon" />
          </button>
        )}
      </span>
    );
  }
}

export default connect(
  null,
  {
    showModalForAttachments,
  }
)(AttachmentsCellRenderer);
